import React, { useContext } from 'react';
import { ResultsContext } from './ResultsDataProvider';
import ClassResultsContainer from './ClassResultsContainer';
import StudentResultsContainer from './StudentResultsContainer';

const ResultsContainer = (props) => {
  const resultsData = useContext(ResultsContext);
  const {
    meQuery: { me: { isStudent } = {} },
    isPPC,
  } = resultsData;
  const componentProps = {
    ...resultsData,
    ...props,
    isQB: !isPPC,
  };
  return (
    <React.Fragment>
      {isStudent ? (
        <StudentResultsContainer {...componentProps} />
      ) : (
        <ClassResultsContainer {...componentProps} />
      )}
    </React.Fragment>
  );
};

export default ResultsContainer;
